import React from "react";
import PropTypes from "prop-types";
import { Banner, Text } from "../../../../components";

const BannerPages = ({
  subtitle,
  bannerTitle,
  contentWidth,
  noBreadCrumbs,
}) => {
  return (
    <Banner
      sectionName="Banner Residencial"
      variant="quaternary"
      bannerTitle={bannerTitle}
      contentWidth={contentWidth}
      noBreadCrumbs={noBreadCrumbs}
    >
      <Text size="lg">{subtitle}</Text>
    </Banner>
  );
};

BannerPages.defaultProps = {
  bannerTitle: null,
  contentWidth: null,
  noBreadCrumbs: false,
};

BannerPages.propTypes = {
  subtitle: PropTypes.string.isRequired,
  bannerTitle: PropTypes.string,
  contentWidth: PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
  }),
  noBreadCrumbs: PropTypes.bool,
};

export default BannerPages;
